import { Box, Grid, styled, useMediaQuery, useTheme } from '@mui/material';
import React, { useContext } from 'react';

// import internalCard from "../../Images/payment/internalCard.svg";
// import creditCard from "../../Images/payment/creditCard.svg";
// import bankCard from "../../Images/payment/bankCard.svg";
// import visa from '../../Images/payment/visa.svg';
// import master from '../../Images/payment/master.svg';

import { paymentAccountType } from '../../FreedomConstants/freedomConstants';
import FreedomTypographyText from '../../Components/SharedComponent/FreedomTypographyText/FreedomTypographyText';
import { capitalizeFullName, getStringProduct } from '../../utils/utilityFunctions';
import { paymentsvg, topNavbar } from '../../url/SvgLinks';
import { ColorModeContext } from '../../store';

const StyledImage = styled('img')(({ theme, height, width }) => ({
  height: height || '70px',
  width: width || '70px',
  [theme.breakpoints.up('xll')]: {
    height: getStringProduct(1.25, height || '70px'),
    width: getStringProduct(1.25, width || '70px')
  },
  [theme.breakpoints.up('xlll')]: {
    height: getStringProduct(1.66, height || '70px'),
    width: getStringProduct(1.66, width || '70px')
  },
  [theme.breakpoints.up('xl4')]: {
    height: getStringProduct(2.46, height || '70px'),
    width: getStringProduct(2.46, width || '70px')
  }
}));

const internalCard = paymentsvg.internalCard;
const internalCardLight = paymentsvg.internalCardLight;
const creditCard = paymentsvg.creditCard;
const creditCardLight = paymentsvg.creditCardLight;
const bankCard = paymentsvg.bankCard;
const bankCardLight = paymentsvg.bankCard;
const visa = paymentsvg.visa;
const master = paymentsvg.master;
const FreedomIcon = topNavbar.freedomIcon1;

const PaymentCard = (props) => {
  const xl4 = useMediaQuery((theme) => theme.breakpoints.up('xl4'))
  const xlll = useMediaQuery((theme) => theme.breakpoints.up('xlll'))
  const xll = useMediaQuery((theme) => theme.breakpoints.up('xll'))
  const theme = useTheme();
  const {
    colorMode: { mode }
  } = useContext(ColorModeContext);
  const { paymentPayMethod, username } = props;
  const cardImage =
    paymentPayMethod === paymentAccountType.internalAccount
      ? mode === 'light'
        ? internalCardLight
        : internalCard
      : paymentPayMethod === paymentAccountType.creditCardAccount
      ? mode === 'light'
        ? creditCardLight
        : creditCard
      : paymentPayMethod === paymentAccountType.bankAccount
      ? mode === 'light'
        ? bankCardLight
        : bankCard
      : '';
  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        borderRadius: '10px',
        backgroundSize: 'cover',
        display: 'flex',
        backgroundImage: `url(${cardImage})`,
        backgroundRepeat: 'no-repeat',
        [theme.breakpoints.up('xll')]: {
          borderRadius: getStringProduct(1.25, '10px')
        },
        [theme.breakpoints.up('xlll')]: {
          borderRadius: getStringProduct(1.66, '10px')
        },
        [theme.breakpoints.up('xl4')]: {
          borderRadius: getStringProduct(2.46, '10px')
        }
      }}
    >
      <Grid
        container
        justifyContent={'space-between'}
        direction={'column'}
        sx={{
          margin: '16px',
          [theme.breakpoints.up('xl4')]: { margin: getStringProduct(1.25, '16px') },
          [theme.breakpoints.up('xl4')]: { margin: getStringProduct(1.66, '16px') },
          [theme.breakpoints.up('xl4')]: { margin: getStringProduct(2.46, '16px') }
        }}
      >
        <Grid item>
          <FreedomTypographyText textalign="left" fontFamily="Poppins" fontsize={'16px'} fontweight={500} color={theme.palette.text.primary}>
            {paymentPayMethod === paymentAccountType.internalAccount ? 'Freedom Internal Account' : paymentPayMethod === paymentAccountType.creditCardAccount ? 'Card Payment' : paymentPayMethod === paymentAccountType.bankAccount ? 'Bank' : ''}
          </FreedomTypographyText>
        </Grid>
        <Grid item container justifyContent="space-between" alignItems="center" direction="row">
          <Grid item>
            <FreedomTypographyText textalign="left" fontFamily="Poppins" fontsize={'16px'} fontweight={500} color={theme.palette.text.primary}>
              {paymentPayMethod === paymentAccountType.internalAccount
                ? capitalizeFullName(username)
                : paymentPayMethod === paymentAccountType.creditCardAccount
                ? ''
                : paymentPayMethod === paymentAccountType.bankAccount
                ? capitalizeFullName(username)
                : ''}
            </FreedomTypographyText>
          </Grid>
          <Grid item>
            {paymentPayMethod === paymentAccountType.creditCardAccount ? (
              <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={xl4 ? 2.46 * 1 : xlll ? 1.66 * 1 : xll ? 1.25 * 1 : 1}>
                <Grid item>
                  <StyledImage src={master} />
                </Grid>
                <Grid item>
                  <StyledImage src={visa} />
                </Grid>
              </Grid>
            ) : paymentPayMethod === paymentAccountType.internalAccount ? (
              <StyledImage src={FreedomIcon} />
            ) : paymentPayMethod === paymentAccountType.bankAccount ? (
              ''
            ) : (
              ''
            )}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PaymentCard;
